import {useQuery} from '@tanstack/react-query';

import {getEventTemplates} from '../api';
import {QUERY__CRYPTO_EVENT_TEMPLATES} from '../queryKeys';

export const useGetEventTemplates = () => {
  return useQuery({
    queryKey: [QUERY__CRYPTO_EVENT_TEMPLATES],
    queryFn: () => getEventTemplates(),
  });
};
